import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderService } from 'src/app/shared/services/header.service';

@Component({
  selector: 'app-manage-settings',
  templateUrl: './manage-settings.component.html',
  styleUrls: ['./manage-settings.component.scss']
})
export class ManageSettingsComponent implements OnInit {
  page:number;
  lang: string;
  imgURL: any;
  currentPage:number;

  constructor(
    private _header: HeaderService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.lang = localStorage.getItem("lang");
    this._header.manageSettingsHeading.next(true);
    this.imgURL = "../../../../../assets/icons/img-thumb.svg";
    this.route.queryParams.subscribe(params => {
      let paramPage = params['page'];
      this.page = parseInt(params['page']);
      if (typeof paramPage == 'undefined') {
        this.page = 1;
      } else {
        this.page = parseInt(paramPage);
      }
    });

    if (this.page) {
      this.currentPage = this.page;
    }
  }

  ngOnDestroy() {
    this._header.manageSettingsHeading.next(false);
  }
}
